module.exports = __webpack_public_path__ + "static/media/19.7113cf19.mp3";